import { render, staticRenderFns } from "./MonitoringPlanCard.vue?vue&type=template&id=2ef12906&"
import script from "./MonitoringPlanCard.vue?vue&type=script&lang=js&"
export * from "./MonitoringPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports